import React from 'react';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
// TrustedBySection temporarily disabled
import FeaturesSection from './FeaturesSection';
import ShowcaseSection from './ShowcaseSection';
import PricingSection from './PricingSection';
import FAQSection from './FAQSection';
import Footer from './Footer';

export default function LandingPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        {/* <TrustedBySection /> */}
        <FeaturesSection />
        <ShowcaseSection />
        <PricingSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
} 